import React from 'react';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';

function InventorySourceDropdown(props) {
  const {
    label,
    currentValue,
    setContextValue,
    options, // Array of { key: string, value: string, display: string }
    defaultOptionLabel, // E.g., "Select Platform ID"
    manualEntryPromptText,
    isLoading,
    loadingText = "Loading...", // Default loading text,
    id,
  } = props;

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === 'manual') {
      const manualId = prompt(manualEntryPromptText);
      if (manualId) {
        setContextValue(manualId);
      }
    } else if (selectedValue) {
      setContextValue(selectedValue);
    } else {
      // When "Select..." (empty value) is chosen, set context value to null (or appropriate empty state)
      setContextValue(null); 
    }
  };

  if (isLoading) {
    return (
      <tr>
        <th>{label}</th>
        <td>
          <div className="d-flex align-items-center">
            <Spinner animation="border" size="sm" />
            <span className="ms-2">{loadingText}</span>
          </div>
        </td>
      </tr>
    );
  }

  const currentValInOptions = options.some(opt => opt.value === currentValue);

  return (
    <tr>
      <th>{label}</th>
      <td>
        <Form.Select
          onChange={handleSelectChange}
          className="compact-select"
          value={currentValue || ""}
          id={id}
        >
          <option value="">
            {defaultOptionLabel} ({options.length} available)
          </option>
          {options.map(opt => (
            <option key={opt.key} value={opt.value}>
              {opt.display}
            </option>
          ))}
          {/* Add manually entered ID if it exists but isn't in the dropdown options */}
          {currentValue && !currentValInOptions && (
            <option key={currentValue} value={currentValue}>
              {currentValue} (Manual Entry)
            </option>
          )}
          <option value="manual">Enter manually...</option>
        </Form.Select>
      </td>
    </tr>
  );
}

export default InventorySourceDropdown;
